import React from 'react';
import { IconProps } from './type';

const ReceiptIcon = (props: IconProps) => {
  const { w, h, fill = '#fff' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${w ? w : '20'}`}
      height={`${h ? h : '20'}`}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={fill}
        d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"
      />
      <path
        fill={fill}
        d="M9 7h6v2H9V7zm7 0h2v2h-2V7zM9 10h6v2H9v-2zm7 0h2v2h-2v-2z"
      />
    </svg>
  );
};

export default ReceiptIcon;
